import { SearchPersonResultsv2 } from './SearchPersonResultsv2';

export function SearchPersonResultsContainerv2() {
  return <SearchPersonResultsv2 />;
}
